import { useModal } from "@/contexts/ModalContext";

const MAX_VISIBLE = 4;

interface MediaCarouselProps {
  media: string[];
  className?: string;
  imageSize?: string;
}

export const MediaCarousel = ({ media, className = "", imageSize = "w-20 h-20" }: MediaCarouselProps) => {
  const { openModal } = useModal();

  if (!media || media.length === 0) return null;

  const visibleMedia = media.slice(0, MAX_VISIBLE);
  const remaining = media.length - MAX_VISIBLE;

  return (
    <div className={`flex mx-1 gap-2 flex-wrap items-center ${className}`}>
      {visibleMedia.map((item, index) => (
        <img
          key={index}
          src={item}
          alt={`Media ${index + 1}`}
          className={`${imageSize} object-cover rounded-xl flex-shrink-0 cursor-pointer transition-all duration-200 hover:brightness-75 hover:scale-105 hover:shadow-md`}
          onClick={() => openModal('media-carousel', { media, initialIndex: index })}
        />
      ))}
      {remaining > 0 && (
        <button
          className="w-14 h-14 md:w-32 md:h-32 rounded-xl flex-shrink-0 bg-gray-100 border border-gray-200 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors"
          onClick={() => openModal('media-carousel', { media, initialIndex: MAX_VISIBLE })}
          aria-label={`Show ${remaining} more photos`}
        >
          <h4 className="text-gray-700 text-xs md:text-base font-semibold">+{remaining}</h4>
          <span className="text-[10px] md:text-sm text-gray-500 mt-0.5 hidden md:inline">foto</span>
        </button>
      )}
    </div>
  );
};
